import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=7f2b08ec&scoped=true&"
import script from "./myorderdetails.js?vue&type=script&lang=js&"
export * from "./myorderdetails.js?vue&type=script&lang=js&"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=7f2b08ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b08ec",
  null
  
)

export default component.exports